import { render, staticRenderFns } from "./AdvancedCustomerTranRecord.vue?vue&type=template&id=1e496583&scoped=true&"
import script from "./AdvancedCustomerTranRecord.vue?vue&type=script&lang=js&"
export * from "./AdvancedCustomerTranRecord.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedCustomerTranRecord.vue?vue&type=style&index=0&id=1e496583&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e496583",
  null
  
)

export default component.exports